module.exports = __webpack_public_path__ + "static/media/product integrated.9b5bf15e.webp";